import axios from 'axios';

const getApiUrl = () => {
    if (process.env.REACT_APP_IS_LOCAL_DEV === "true") {
        return "http://localhost:8000/api/v1";
    }
    const hostname = window.location.hostname;
    if (hostname.includes("ngrok-free.app")) {
        return `https://${hostname}/api/v1`;
    }
    return process.env.REACT_APP_API_URL || "https://backend.app.juricapital.com.br/api/v1";
};

const API_URL = getApiUrl();
const API_KEY = process.env.REACT_APP_API_KEY;

export const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY, // Note: ideally shouldn't be hardcoded in frontend like this long term, but preserving current logic
    }
});

apiClient.interceptors.request.use(config => {
    if (config.data instanceof FormData) {
        // Axios 1.x uses AxiosHeaders — .delete() is the reliable API
        config.headers.delete('Content-Type');
    }
    return config;
});

apiClient.interceptors.response.use(
    response => response,
    error => {
        // Handle common errors globally but preserve the response object
        // if available so components can check status codes (like 409)
        const detail = error.response?.data?.detail;
        const message = (typeof detail === 'string' ? detail : detail?.message) || error.message || "Erro de conexão";
        
        const enhancedError = new Error(message);
        if (error.response) {
            enhancedError.response = error.response;
        }
        
        return Promise.reject(enhancedError);
    }
);
